import { Tag, Text, Tooltip } from '@chakra-ui/react';

type Props = {
  team: string;
};

export default function TeamTag({ team }: Props) {
  return (
    <Tag ml={2} colorScheme="blue" userSelect="none">
      <Tooltip label={team}>
        <Text textOverflow="ellipsis" noOfLines={1}>
          {team}
        </Text>
      </Tooltip>
    </Tag>
  );
}
